import React, { useState, useEffect } from "react";
import { ImageUrl } from "../../utils/constants";
import PropTypes from "prop-types";
import LazyImage from "../common/LazyImage/LazyImage";
// import { ChallengeHeader } from "./style";
import SkeletonLoder from "../common/skeletonLoder";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import parse from 'react-html-parser';
import {StarIconSmall, LaunchIcon} from '../../utils/icons'
import { Layout,Container } from "../MainEvents/CompanyLiveEvents/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CompanyCard } from "../MainEvents/CompanyLiveEvents/styles";
import { NewBackArrowIconEventPage, NewNextArrowIconEventPage, DatePickerIconUserEvents, PeopleIconForRegisteredUsers } from '../../utils/icons'
import moment from "moment";
import { convertDateInTimezone } from "../../utils/methods";
// import { ReservedButton } from "./styles";
import { ReservedButton,SliderContainer } from "../MainEvents/styles";

// Custom Next Arrow Component with PropTypes
const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  const isLastSlide = currentSlide === slideCount - 1;
  if (isLastSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-next"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

NextArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

// Custom Prev Arrow Component with PropTypes
const PrevArrow = ({ currentSlide, onClick }) => {
  const isFirstSlide = currentSlide === 0;
  if (isFirstSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-prev"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

PrevArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

const RecommendedCard = ({
  RecommendedEventData,
  isActivity,
  history,
  RecommendedEventDataLoading,
  isQuizCard
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, setSliderRef] = useState(null);

  useEffect(() => {
    const interval = window.setInterval(() => {
      if (RecommendedEventData.length && sliderRef) {
        sliderRef.slickNext();
      }
    }, 88000);

    return () => window.clearInterval(interval);
  }, [RecommendedEventData.length, sliderRef]);

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  const companyLive = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow currentSlide={currentSlide} slideCount={RecommendedEventData.length} />,
    prevArrow: <PrevArrow currentSlide={currentSlide} />,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={RecommendedEventData.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={RecommendedEventData.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
    ],
  };

  const convertMonthFromDate = (dateString) => {
    const temp = dateString.split(" ");
    return temp.join(" ");
  };

  return (
    <React.Fragment>
      {RecommendedEventDataLoading ? (
        <React.Fragment>
          <SkeletonLoder
            width={"1248px"}
            height={"450px"}
          ></SkeletonLoder>
        </React.Fragment>
      ) : (
        <Layout style={{background:'#FEFEFE', border:'0.75px solid #dcdcdc' }} margin={"0 0 5px 0"} padding={"20px 20px 30px 20px"} background={'#fff'} >
          <div className="headingMain">
            <div style={{ gap: "12px" }} className="heading">
              <div style={{display: 'flex', alignItems: 'center'}}>
                {StarIconSmall("#184A61")}
              </div>
              {"Featured Challenges"}
            </div>
            {RecommendedEventData?.length > 1 ? (
              <div className="arrows">
                <div
                  className="iconBackground"
                  onClick={() => sliderRef?.slickPrev()}
                  style={{ 
                    opacity: currentSlide === 0 ? 0 : 1,
                    cursor: currentSlide === 0 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewBackArrowIconEventPage()}
                </div>
                <div className="text">
                  {currentSlide + 1} / {RecommendedEventData?.length}
                </div>
                <div
                  className="iconBackground"
                  onClick={() => currentSlide < RecommendedEventData?.length - 1 && sliderRef?.slickNext()}
                  style={{ 
                    opacity: currentSlide === RecommendedEventData?.length - 1 ? 0 : 1,
                    cursor: currentSlide === RecommendedEventData?.length - 1 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {NewNextArrowIconEventPage()}
                </div>
              </div>
            ) : null}
          </div>
          <Container>
            {RecommendedEventData?.length > 0 && (
              <SliderContainer
                display="flex"
                content="center"
                shadow="0px 8px 25px 0px #0D427040"
              >
                <Slider
                  {...companyLive}
                  ref={(slider) => setSliderRef(slider)}
                >
                  {RecommendedEventData?.length > 0 &&
                    RecommendedEventData.map((data, index) => (
                      <div className="card featCard" key={index} style={{paddingRight:'0', marginRight:'-30px !important'}}>
                        <CompanyCard
                          className="featChallanges" 
                          detailsCardPadding="0 0 10px 20px"
                          width="1248px"
                          onClick={() => history.push(`/company/challenges/activity-launch/${data?.id}`)}
                        >
                          <LazyImage
                            div={"imageCard featImg"}
                            src={`${ImageUrl}/${data.image}`}
                            alt="category"
                          />
                          <div className="detailsCard" style={{border:'1px solid #DCDCDC',padding:'0 20px 20px 20px',borderRadius:'0 8px 8px 0'}}>
                            <div className="title">
                              {isQuizCard ? "Launch Quiz: Based on the following articles" : 
                                isActivity ? data?.title : data?.title}
                            </div>
                            {!isQuizCard && (
                              <div className="description">
                                {parse(data?.body || "")}
                              </div>
                            )}
                            {data.start_date && (
                              <div className="date">
                                <div className="icon">
                                  <DatePickerIconUserEvents />
                                </div>
                                <div className="detail">
                                  {convertMonthFromDate(
                                    moment(
                                      convertDateInTimezone(data?.start_date)._d
                                    ).format("MMM D, YYYY | hh:mm A")
                                  )}
                                  {!data.is_all_day_event && data.end_date && 
                                    ` IST - ${moment(
                                      convertDateInTimezone(data?.end_date)._d
                                    ).format("MMM D, YYYY | hh:mm A")} IST`
                                  }
                                </div>
                              </div>
                            )}
                            {data?.attendees_list?.length > 0 && data.event_type !== "theme" ? (
                              <div className="date">
                                <div className="icon">
                                  <PeopleIconForRegisteredUsers />
                                </div>
                                <div className="detail">
                                  {data?.attendees_list?.length} Registered{" "}
                                  {data?.attendees_list?.length > 1 ? "Users" : "User"}
                                </div>
                              </div>
                            ) : null}

                            {data?.event_participants_count > 0 && data.event_type === "theme" ? (
                              <div className="date">
                                <div className="icon">
                                  <PeopleIconForRegisteredUsers />
                                </div>
                                <div className="detail">
                                  {data?.event_participants_count} joined{" "}
                                  {data?.event_participants_count > 1 ? "users" : "user"}
                                </div>
                              </div>
                            ) : null}

                            <div className="moving-btn" style={{display:'flex', alignItems:'center', justifyContent:'center', marginTop:'auto'}}>
                              <ReservedButton 
                                active={true} 
                                width="436px" 
                                height="40px"
                                onClick={() => history.push(`/company/challenges/activity-launch/${data?.id}`)}
                              >
                                <div className="icon" style={{marginRight: "8px"}}>{LaunchIcon("#FEFEFE")}</div>
                                {"Launch Challenge"}
                              </ReservedButton>
                            </div>
                          </div>
                        </CompanyCard>
                      </div>
                    ))}
                </Slider>
              </SliderContainer>
            )}
          </Container>
        </Layout>
      )}
    </React.Fragment>
  );
};

RecommendedCard.propTypes = {
  RecommendedEventData: PropTypes.array,
  margin: PropTypes.string,
  isActivity: PropTypes.bool,
  history: PropTypes.object.isRequired,
  RecommendedEventDataLoading: PropTypes.bool,
  themesHeader: PropTypes.object,
  heading: PropTypes.string,
  isCoachEvent: PropTypes.bool,
  isQuizCard: PropTypes.bool
};

const mapStateToProps = (state) => ({
  themesHeader: state.profileData.themesHeader
});

export default connect(mapStateToProps, null)((withTranslation())(RecommendedCard));